import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { useI18n } from 'locales';
import { useState } from 'react';
import PasswordStrengthChecklist, { passwordStrengthCriteria } from './PasswordStrengthChecklist';
import TextInput from './TextInput';

export { passwordStrengthCriteria };

const PasswordInput = ({
  value = '',
  error,
  helper,
  showChecklist = false,
  ...props
}) => {
  const t = useI18n();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextInput
      type={showPassword ? 'text' : 'password'}
      value={value}
      error={error}
      helper={(showChecklist && !error) ? <PasswordStrengthChecklist value={value} /> : helper}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            onClick={() => setShowPassword((v) => !v)}
            edge="end"
            size="small"
            aria-label={showPassword ? t('Hide password') : t('Show password')}
          >
            <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} style={{ fontSize: '0.9rem' }} />
          </IconButton>
        </InputAdornment>
      }
      {...props}
    />
  );
};

export default PasswordInput;
